import { render, staticRenderFns } from "./CUUserManagement.vue?vue&type=template&id=60165c24&scoped=true&"
import script from "./CUUserManagement.vue?vue&type=script&lang=js&"
export * from "./CUUserManagement.vue?vue&type=script&lang=js&"
import style0 from "./CUUserManagement.vue?vue&type=style&index=0&id=60165c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60165c24",
  null
  
)

export default component.exports